import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import styles from "./GuestFloorPlan.module.css";
import { SubmitButton, TextComponent } from "../../../../components";
import floorImg from "../../../../assets/venueImg.png";

const GuestFloorPlan = () => {
  const RSVP = useSelector((state) => state.EventPlanningReducer.RSVP);
  const navigate = useNavigate();
  return (
    <div className={styles.mainCont}>
      <TextComponent text={"Floor plan"} textClass={styles.heading} />
      <div className={styles.imgDiv}>
        <img src={RSVP?.floor_image ? RSVP?.floor_image : floorImg} />
      </div>
      <div className={styles.btnDiv}>
        <SubmitButton
          title="Back"
          btnClass={styles.btn}
          onClick={() =>
            navigate("/RsvpDetails", {
              state: { headrTitle: "RSVP" },
            })
          }
        />
      </div>
    </div>
  );
};

export default GuestFloorPlan;
